// Cookie banner for the app (app.px7.training). Most visitors arrive
// already logged in and have seen the Legal pages during signup, but we
// still surface this once per browser so EU first-timers aren't surprised.
//
// Scope: essentials only — the app doesn't load analytics or tracking.
// Stripe loads on billing routes, Turnstile on a handful of auth forms;
// both are disclosed on /cookies.
//
// The banner hides completely after the user clicks "Got it" — keyed in
// localStorage with a version suffix so a future policy change can force
// re-display with a single bump.
import { useEffect, useState } from "react";

const STORAGE_KEY = "px7.cookies.ack.v1";
const COOKIES_URL = "https://px7.training/cookies";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (window.localStorage.getItem(STORAGE_KEY)) return;
    } catch {
      // localStorage blocked — still render so the user can dismiss; just
      // won't persist across sessions.
    }
    setVisible(true);
  }, []);

  function dismiss() {
    try {
      window.localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch { /* ignore */ }
    setVisible(false);
  }

  if (!visible) return null;
  return (
    <div
      role="dialog"
      aria-label="Cookie notice"
      className="fixed bottom-0 inset-x-0 z-50 p-3 safe-bottom"
    >
      <div className="mx-auto max-w-3xl rounded-xl border border-px-line bg-px-surface-hi/95 backdrop-blur-sm shadow-lg p-4 flex flex-col sm:flex-row sm:items-center gap-3">
        <p className="text-xs sm:text-sm text-px-text flex-1 leading-relaxed">
          One essential cookie signs you in. Stripe + Turnstile load only on
          checkout and signup forms. No analytics, no tracking.{" "}
          <a
            href={COOKIES_URL}
            target="_blank"
            rel="noreferrer noopener"
            className="text-px-green underline underline-offset-2"
          >
            Details
          </a>.
        </p>
        <button
          type="button"
          onClick={dismiss}
          className="px-btn-primary text-xs whitespace-nowrap"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
